import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import snakeCase from 'lodash/snakeCase';

export const BaseEventType = {
  domain: (val) => isString(val) && !isEmpty(val) && snakeCase(val) === val,
  object: (val) => isString(val) && !isEmpty(val) && snakeCase(val) === val,
  verb: (val) => isString(val) && !isEmpty(val) && snakeCase(val) === val,
  timestamp: (val) => isNumber(val),
  clientSessionId: (val) => isString(val) && !isEmpty(val),
  page: {
    app: (val) => isString(val) && !isEmpty(val),
    environment: (val) => isString(val) && !isEmpty(val),
    userAgent: (val) => isString(val) && !isEmpty(val),
    url: (val) => isString(val) && !isEmpty(val),
    name: (val) => isString(val) && !isEmpty(val),
  },
  details: {
    network: {
      effectiveType: (val) => isString(val) && !isEmpty(val),
    },
    viewport: {
      size: (val) => isString(val) && !isEmpty(val),
      innerWidth: (val) => isNumber(val),
      innerHeight: (val) => isNumber(val),
      outerWidth: (val) => isNumber(val),
      outerHeight: (val) => isNumber(val),
      pageXOffset: (val) => isNumber(val),
      pageYOffset: (val) => isNumber(val),
      availWidth: (val) => isNumber(val),
      availHeight: (val) => isNumber(val),
    },
  },
};
